/**
 * Products Module Configuration
 *
 * Manages products that can be associated with properties and showcases.
 * Hidden from top-level sidebar - accessed via Settings navigation group.
 */

import type { AppModule } from '@/types/architecture'
import routes from './routes'

const productsModule: AppModule = {
    id: 'products',

    navigation: {
        label: 'Products',
        icon: 'package',
        path: '/products',
        order: 91,
        moduleKey: 'settings.products',
        showInSidebar: false, // Accessed via Settings group


        pages: [
            {
                label: 'All Products',
                path: '/products',
            },
            {
                label: 'Add Product',
                path: '/products/create',
            },
        ],
    },

    routes,
}

export default productsModule
